<span [id]="id" [attr.data-cy]="id" class="d-block">
  <ng-content></ng-content>
</span>
